(function (window, document) {
  'use strict';

  var MOBILE_BREAKPOINT = 767;

  function WorkMasonry(selector) {
    this.selector = selector;
    this.element = document.querySelector(selector);
    this.instance = null;
    this.isMobile = this.getIsMobile();

    this.handleResize = this.handleResize.bind(this);
    this.handleImageLoad = this.handleImageLoad.bind(this);
  }

  WorkMasonry.prototype.getIsMobile = function () {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  };

  WorkMasonry.prototype.canInit = function () {
    return !!this.element && typeof window.Masonry !== 'undefined';
  };

  WorkMasonry.prototype.getOptions = function () {
    return {
      itemSelector: '.work-masonry-item',
      columnWidth: '.work-masonry-sizer',
      percentPosition: false,
      gutter: this.getIsMobile() ? 0 : 25,
      transitionDuration: 0,
    };
  };

  WorkMasonry.prototype.bindImageEvents = function () {
    var images;
    var index;

    images = this.element.querySelectorAll('img');

    for (index = 0; index < images.length; index += 1) {
      if (images[index].complete) {
        continue;
      }

      images[index].addEventListener('load', this.handleImageLoad);
      images[index].addEventListener('error', this.handleImageLoad);
    }
  };

  WorkMasonry.prototype.handleImageLoad = function () {
    this.layout();
  };

  WorkMasonry.prototype.handleResize = function () {
    var nextIsMobile;

    nextIsMobile = this.getIsMobile();

    if (nextIsMobile !== this.isMobile) {
      this.isMobile = nextIsMobile;
      this.rebuild();
      return;
    }

    this.layout();
  };

  WorkMasonry.prototype.init = function () {
    if (!this.canInit()) {
      return;
    }

    this.instance = new window.Masonry(this.element, this.getOptions());
    this.bindImageEvents();
    window.addEventListener('resize', this.handleResize, { passive: true });
    this.layout();
  };

  WorkMasonry.prototype.layout = function () {
    if (!this.instance) {
      return;
    }

    this.instance.layout();
  };

  WorkMasonry.prototype.rebuild = function () {
    if (!this.instance) {
      return;
    }

    this.instance.destroy();
    this.instance = new window.Masonry(this.element, this.getOptions());
    this.layout();
  };

  function initWorkMasonry() {
    var masonry;

    masonry = new WorkMasonry('[data-work-masonry]');
    masonry.init();
  }

  window.addEventListener('load', initWorkMasonry);
})(window, document);
